import PropTypes from "prop-types";
import deferredStyles from "../NativeAppBanner/deferred.css";
import classnames from "classnames";

const AppLogo = ({ classes }) => {
  return (
    <div
      className={classnames(deferredStyles.sbAppIcon, classes)}
      role="img"
      aria-hidden="true"
    />
  );
};

AppLogo.propTypes = {
  classes: PropTypes.string
};

export default AppLogo;
